import {FieldMetadata} from '@conform-to/react';
import {Input} from '~/components/ui/Input';
import {ComponentProps} from '@styled-system/types';

type PandaFormInputProps = {
  meta: FieldMetadata<string>
} & Omit<ComponentProps<typeof Input>, 'name' | 'defaultValue'>;

const PandaFormInput = ({meta, ...rest}: PandaFormInputProps) => {
  return (
    <div>
      <Input
        name={meta.name}
        defaultValue={meta.initialValue}
        {...rest}
      />
      <div>{meta.errors}</div>
    </div>

  );
};

export default PandaFormInput;
